import { useState as m, useEffect as l, useCallback as $ } from "react";
import { useAnimation as g } from "motion/react";
import { atom as k, useAtom as x } from "jotai";
const S = () => (t) => {
  if (!t)
    return "1/1";
  const e = t.match(/\/(\d+)x(\d+)\//);
  if (!e)
    return "1/1";
  const o = Number(e[1]), s = Number(e[2]);
  return !o || !s ? "1/1" : `${o}/${s}`;
}, y = "(prefers-reduced-motion: no-preference)", R = typeof window > "u", v = () => R ? !0 : !window.matchMedia(y).matches, B = () => {
  const [t, e] = m(v);
  return l(() => {
    const o = window.matchMedia(y), s = (r) => {
      e(!r.matches);
    };
    return o.addEventListener && o.addEventListener("change", s), () => {
      o.removeEventListener && o.removeEventListener("change", s);
    };
  }, []), t;
}, I = ({
  x: t = 0,
  y: e = 0,
  rotation: o = 0,
  scale: s = 1,
  timing: r = 150,
  springConfig: n = {
    stiffness: 300,
    damping: 10,
    mass: 1
  }
}) => {
  const a = B(), [i, u] = m(!1), c = g();
  l(() => {
    i ? c.start({
      display: "inline-block",
      transform: `translate(${t}px, ${e}px) rotate(${o}deg) scale(${s})`,
      transition: { type: "spring", ...n }
    }) : c.start({
      display: "inline-block",
      transform: "translate(0px, 0px) rotate(0deg) scale(1)",
      transition: { type: "spring", ...n }
    });
  }, [i]), l(() => {
    if (!i)
      return;
    const w = window.setTimeout(() => {
      u(!1);
    }, r);
    return () => {
      window.clearTimeout(w);
    };
  }, [i]);
  const d = $(() => {
    u(!0);
  }, []);
  return [a ? {} : c, d];
}, f = (t) => {
  const [e, o] = m(!1);
  return l(() => {
    const s = window.matchMedia(t);
    o(s.matches);
    const r = (n) => o(n.matches);
    return s.addEventListener("change", r), () => s.removeEventListener("change", r);
  }, [t]), e;
}, O = () => {
  const t = {
    mobile: f("(max-width: 767px)"),
    tablet: f("(min-width: 768px) and (max-width: 1024px)"),
    desktop: f("(min-width: 1025px)"),
    active: ""
  };
  switch (!0) {
    case t.mobile:
      t.active = "mobile";
      break;
    case t.tablet:
      t.active = "tablet";
      break;
    case t.desktop:
      t.active = "desktop";
      break;
  }
  return t;
}, U = () => {
  const [t, e] = m(!1);
  return l(() => {
    e(!0);
  }, []), t;
}, L = 500;
function j(t, e) {
  const [o, s] = m(t);
  return l(() => {
    const r = setTimeout(
      () => s(t),
      e || L
    );
    return () => {
      clearTimeout(r);
    };
  }, [t, e]), o;
}
const h = (t) => t.replace(/^\/|\/$/g, "");
let b = "https://imgproxy.frackend.net";
function C(t) {
  b = t;
}
function N() {
  return b;
}
const T = () => (t, e) => {
  const {
    width: o,
    format: s,
    height: r,
    transformationBackground: n,
    quality: a,
    auto: i,
    gravity: u = "ce"
  } = e ?? {}, c = [
    `resizing_type:${i ? "fit" : "fill"}`,
    (r || o) && `size:${o ?? 0}:${r ?? 0}`,
    `g:${u}`,
    a && `quality:${a}`,
    n && `background:${n}`
  ].filter(Boolean), d = btoa(h(t)), p = `${h(
    b
  )}/insecure/${h(c.join("/"))}/${d}`;
  return s ? `${p}.${s}` : p;
}, M = k(0), Q = (t) => {
  const [e, o] = x(M);
  l(() => {
    t.state === "loading" && o(window.scrollY);
  }, [t]), l(() => {
    t.state === "idle" && e !== 0 && window.scrollY !== 0 && setTimeout(() => {
      window.scrollTo(0, e);
    }, 100);
  }, []);
}, q = ({
  imageMobile: t,
  imageTablet: e,
  imageDesktop: o
}) => {
  const s = S(), r = s(
    t || e || o
  ) || "1/1", n = s(
    e || o || t
  ) || "3/4", a = s(
    o || e || t
  ) || "16/10";
  return {
    "--aspect-ratio-mobile": r,
    "--aspect-ratio-tablet": n,
    "--aspect-ratio-desktop": a
  };
}, D = () => (t, e) => {
  const { height: o, width: s, smart: r, quality: n, focus: a, format: i } = e ?? {}, u = [], c = [
    n && `quality(${n})`,
    a && `focal(${a})`,
    i && `format(${i})`
  ].filter(Boolean).join(":");
  c && u.push(`filters:${c}/`);
  const d = [
    `${s ?? 0}x${o ?? 0}/`,
    r && "smart/",
    ...u
  ].filter(Boolean);
  return `${t}/m/${d.join("")}`;
};
export {
  N as getImageProxyBaseUrl,
  C as setImageProxyBaseUrl,
  S as useAspectRatioFromStoryblokUrl,
  I as useBoop,
  O as useBreakpoint,
  U as useClientOnly,
  j as useDebounce,
  T as useImgProxyCDN,
  Q as useKeepScrollPosition,
  f as useMediaQuery,
  B as usePrefersReducedMotion,
  q as useStoryblokAspectRatioCSSVariables,
  D as useStoryblokCDN
};
